import { render, staticRenderFns } from "./TripleSummaryChart.vue?vue&type=template&id=82230962&"
import script from "./TripleSummaryChart.vue?vue&type=script&lang=ts&"
export * from "./TripleSummaryChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports